export const environment = {
    production: false,
    claveUnicaUrl: 'https://accounts.claveunica.gob.cl/openid/authorize/',
    claveUnicaTokenUrl: 'https://accounts.claveunica.gob.cl/auth2/token',
    claveUnicaUserInfo: 'https://accounts.claveunica.gob.cl/auth2/userinfo',
    claveUnicaClientId: '4a94478dd25f4430a0a023b87e11170d',
    logoutClaveUnicaUrl: 'https://claveunica.gob.cl/api/v1/usuarios/sessions/logout',
    redirectClaveUnicaUrl: 'https://milicenciamedica.cl/',
    baseUrl: 'https://saludirrecuperable.dev.milicenciamedica.cl/',
    SaludIrrecuperableRecSesion: 'esi-rec-sesion',
    client_id: 'NUEVO_CLIENT_ID',
    oauthTokenUrl: 'https://k6sx9t14c7.execute-api.us-east-1.amazonaws.com/esi-token',
    logout: '/esi-dev-logout',
    disableAuth: false,
    backendUrl: 'https://k6sx9t14c7.execute-api.us-east-1.amazonaws.com',
    clientId: '6req5tk63e0h1gs7vmr5a8r9ks',
    esiEnvironment: 'esi-dev',
    extenderSesion: 'esi-extender-sesion',
    verificarSesion: 'esi-verificar-sesion',
};